import { FC } from 'react'
import styled from 'styled-components'
import * as N from './style'
import NoxLogoSvg from '@/assets/images/nox-logo.svg'

// 共用 NOX 品牌 logo：Nox bull logo 圖像 + NOX 文字
// 用於 landing nav / global header / 任何需要 NOX 品牌處

const Wrap = styled.span<{ $compact?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${p => p.$compact ? '8px' : '12px'};
`

const LogoImg = styled.img<{ $size: number }>`
  width: ${p => p.$size}px;
  height: ${p => p.$size}px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
`

const TextGroup = styled.span`
  display: inline-flex;
  flex-direction: column;
  line-height: 1.2;
`

const Brand = styled.span<{ $compact?: boolean }>`
  font-family: ${N.t.fontHeading};
  font-size: ${p => p.$compact ? '1rem' : '1.125rem'};
  font-weight: 700;
  letter-spacing: 0.12em;
  color: ${N.t.slate950};
`

const Tagline = styled.span`
  font-size: 0.75rem;
  color: ${N.t.slate500};
  margin-top: 2px;
  @media (max-width: 479px) { display: none; }
`

type Props = {
  /** 是否顯示下方 tagline 小字（預設 true）。header 空間小可關掉 */
  showTagline?: boolean
  /** 緊湊模式（較小尺寸），適用 global header 等 64px 區域 */
  compact?: boolean
}

const NoxBrandLogo: FC<Props> = ({ showTagline = true, compact = false }) => {
  const monoSize = compact ? 45 : 50

  return (
    <Wrap $compact={compact}>
      <LogoImg $size={monoSize} src={NoxLogoSvg} alt="NOX" />
      <TextGroup>
        <Brand $compact={compact}>NOX</Brand>
        {showTagline && <Tagline>Trading data, turned into earnings</Tagline>}
      </TextGroup>
    </Wrap>
  )
}

export default NoxBrandLogo
